export default "__VITE_ASSET__Dfy9Kj3___"